import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, Flame, Shield } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useDashboardData } from "@/contexts/DashboardDataContext";
import { useAuthSession } from "@/contexts/AuthSessionContext";

const SolidSummaryWidget = () => {
  const navigate = useNavigate();
  const { data, loading } = useDashboardData();
  const { user } = useAuthSession();
  const [badgeCount, setBadgeCount] = useState<number | null>(null);

  useEffect(() => {
    if (!user?.id) return;
    let cancelled = false;
    (async () => {
      const { count } = await supabase
        .from("user_solid_badges")
        .select("id", { count: "exact", head: true })
        .eq("user_id", user.id);
      if (!cancelled) setBadgeCount(count ?? 0);
    })();
    return () => { cancelled = true; };
  }, [user?.id]);

  const stats = data.solidStats;
  const tier = stats?.prestige_tier && stats.prestige_tier !== "none" ? stats.prestige_tier : "Unranked";

  return (
    <button
      type="button"
      onClick={() => navigate("/profile#solid")}
      className="sticker-press flex w-full items-center gap-4 rounded-[24px] border-4 border-sticker-ink bg-sticker-mint p-4 text-left shadow-sticker-6"
    >
      <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[16px] border-3 border-sticker-ink bg-sticker-surface shadow-sticker-3">
        <Shield className="h-7 w-7 text-sticker-purple" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="sticker-label text-sticker-body">STREAKS & BADGES</p>
        <p className="mt-1 truncate font-sticker-display text-[22px] leading-none text-sticker-ink">
          {loading ? "Loading…" : `${tier} tier`}
        </p>
        <div className="mt-2 flex flex-wrap items-center gap-3 text-[13px] font-bold text-sticker-body">
          <span className="flex items-center gap-1.5"><Flame className="h-4 w-4" />{stats?.solid_streak ?? 0} streak</span>
          <span>•</span>
          <span>{badgeCount ?? 0} badge{badgeCount === 1 ? "" : "s"}</span>
        </div>
      </div>
      <ChevronRight className="h-5 w-5 shrink-0 text-sticker-ink" />
    </button>
  );
};

export default SolidSummaryWidget;
